export * from './flag.types';
export { default as Flag } from './flag.component';
